import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/404_error.svg'


const _hoisted_1 = {
  class: "container",
  role: "main",
  "aria-label": "Page-Not-Found Page"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-center" }, [
    /*#__PURE__*/_createElementVNode("figure", null, [
      /*#__PURE__*/_createCommentVNode(" Image downloaded from ShutterStock and color changed by Marketing dept "),
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        class: "w-50 p-3",
        alt: "404 Error Image"
      })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Page Not Found!", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-secondary mb-0" }, " Maybe this page used to exist or you just spelled something wrong. ", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-secondary mb-0" }, " Chances are you spelled something wrong, please double check the URL? ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", { class: "row" }, [
      _createElementVNode("div", { class: "col text-center" }, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", { class: "mt-3" }, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            title: "Home Button",
            onClick: $setup.handleBackToHome,
            "aria-label": "Back to Home"
          }, " Back to Home ")
        ])
      ])
    ])
  ]))
}